import React from 'react'
import { useIntl } from 'react-intl'
import { MODIFY_SOCIAL_SECURITY_FIELDS } from '../../services/personalInfoConstants'
import FileInput from '../../../../../components/fileInput/FileInput'
import Box from '@mui/material/Box'
import CheckboxInput from '../../../../../components/form/CheckboxInput'
import InfoField from '../../../../../components/InfoField'
import TextInput from '../../../../../components/form/TextInput'
import { ADD_BENEFICIARY_FIELDS } from '../../../beneficiary/services/modifyBeneficiaryConstants'
import { useFormState } from 'react-final-form'

type ModifySocialSecurityNumberProps = {
    allBeneficiaries: any[],
    errors: any
}

const ModifySocialSecurityNumber: React.FC<ModifySocialSecurityNumberProps> = ({ allBeneficiaries, errors }) => {
    const intl = useIntl()
    const { values } = useFormState()

    const BENEFICIARIES_DATA: SelectOption[] = allBeneficiaries ? allBeneficiaries.map((beneficiary: any) => {
        return {
            value: beneficiary[0],
            label: `${beneficiary[1].prenom} ${beneficiary[1].nom}`
        }
    }) : []

    const filesCount = (values[MODIFY_SOCIAL_SECURITY_FIELDS.CERTIFICATE]?.length || 0)
    if (filesCount === 0) {
        values[ADD_BENEFICIARY_FIELDS.COMMENTAIRE] = ''
    }

    return (
        <>
            <InfoField
                label={intl.formatMessage({ id: 'personalInfo.personalData.modifySS.form.beneficiaries.title' })}
                value={
                    <CheckboxInput
                        name={MODIFY_SOCIAL_SECURITY_FIELDS.BENEFICIARIES}
                        data={BENEFICIARIES_DATA}
                        error={errors[MODIFY_SOCIAL_SECURITY_FIELDS.BENEFICIARIES]}
                    />
                }
                direction="column"
                required
            />
            <Box flex="1">
                <FileInput
                    name={MODIFY_SOCIAL_SECURITY_FIELDS.CERTIFICATE}
                    title={intl.formatMessage({ id: 'personalInfo.personalData.modifySS.form.certificate.title' })}
                    label={intl.formatMessage({ id: 'personalInfo.personalData.modifySS.labelSS' })}
                    required
                />
            </Box>
            {filesCount > 0 && <TextInput
                type="commentary"
                maxLength={197}
                maxWidth="unset"
                name={MODIFY_SOCIAL_SECURITY_FIELDS.COMMENTAIRE}
                label={intl.formatMessage({ id: 'sendContract.input.comment.label' })}
                helperText={intl.formatMessage({ id: 'sendContract.input.comment.helperText' })}
            />}
        </>
    )
}

export default ModifySocialSecurityNumber
